import { createContext } from 'react';

export interface NavigationGuardContextType {
  setNeedsConfirmation: (val: boolean) => void;
  requestNavigation: (url: string) => void;
}

export const NavigationGuardContext =
  createContext<NavigationGuardContextType | null>(null);
